import React, { FC, useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { getAliceAgentApp } from 'client/api/services/aliceAgentApps';
import { PageLoader } from 'client/blocks/Loader/PageLoader';
import { routes } from 'client/lib/routes';
import { AliceAgentAppDTO } from 'client/model/aliceAgentApp';

import { AliceAgentAppEditPage } from './AliceAgentAppEditPage';

interface Props {
    skillId: string;
}

export const AliceAgentAppPageContainer: FC<Props> = ({ skillId }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [app, setApp] = useState<AliceAgentAppDTO>();

    const fetchApp = useCallback(async () => {
        try {
            setApp(await getAliceAgentApp(skillId));
        } catch (err) {
            console.error('@Error in fetch getAliceAgentApp', err);
        } finally {
            setIsLoading(false);
        }
    }, [skillId]);

    useEffect(() => {
        fetchApp();
    }, [fetchApp]);

    if (isLoading && !app) return <PageLoader />;
    if (!app) return <Navigate to={routes.app.aliceApps} replace />;

    return (
        <Routes>
            <Route path="draft/settings" element={<AliceAgentAppEditPage app={app} isDraft onSaved={fetchApp} />} />
            <Route
                path="published/settings"
                element={
                    app.published ? (
                        <AliceAgentAppEditPage app={app} isDraft={false} onSaved={fetchApp} />
                    ) : (
                        <Navigate to="../draft/settings" replace />
                    )
                }
            />
            <Route path="*" element={<Navigate to="draft/settings" replace />} />
        </Routes>
    );
};
